import { memoize as lodashMemoize } from 'lodash';
import memize from 'memize';

export function memoizeSingleArg<Fn extends (arg) => any>(fn: Fn): Fn {
  // Lodash works best for a single argument memoization
  return lodashMemoize(fn);
}

export function memoize<Fn extends (...any) => any>(fn: Fn): Fn {
  return memize(fn, {
    maxSize: 1000000,
  }) as any as Fn;
}

const map = {} as Record<string, any>;

export function globallyOnce<Val>(key: string, build: () => Val): Val {
  if (!map[key]) {
    map[key] = build();
  }
  return map[key];
}
